module.exports = __webpack_public_path__ + "static/media/a00e22fb.jpg";